export const TEXT = {
    CREATED: 'Created: ',
    MEMBERS: 'Members: ',
    CREATE_COLLECTION: 'Create Collection',
    EDIT_INFO: 'Edit Info'
};